import React from 'react'
import api from '../../img/api3-removebg-preview.png'

const APIHeader = () => {
  return (
        <div className='account__profile flex'>
            <div className="account__profile__">
                <h5 className="inner__page__title">
                    Your API Keys
                </h5>
                <p>We have given you the power to build awesome 
                    apps that can integrate with our system but we 
                    only ask you repay us the favour by keeping your
                    passkeys secure and private
                </p>
            </div>
            <img className='api__webhook__img' src={api} alt="" />
        </div>
  )
}

export default APIHeader